export default "__VITE_ASSET__jYNQW$qM__"